const x = (y) => {
	const x = {}; __webpack_require__.d(x, y); return x
} 
const y = (x) => (() => (x))
module.exports = x({ ["Suspense"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.Suspense), ["default"]: () => (__WEBPACK_EXTERNAL_MODULE_react__["default"]) });